export var borderWidths = {
    none: "none",
    1: "1px",
    2: "2px",
    3: "3px",
    4: "4px"
};
